import { render, staticRenderFns } from "./draft-badge.vue?vue&type=template&id=5aba4124"
import script from "./draft-badge.vue?vue&type=script&lang=js"
export * from "./draft-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports